module.exports = __webpack_public_path__ + "static/media/20a-02.57c96c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20a/20a-02.jpg
// module id = 243
// module chunks = 0